<template>
  <div id="typing-test-basic-item">
    <div :class="['letter-wrapper', letterStyle]">{{ letter }}</div>
    <div :class="['letter-wrapper', 'key-in', inputLetterStyle]">{{ inputLetter }}</div>
  </div>
</template>

<script lang="js">
import Vue from 'vue'

const BasicAndIntermediateTypingItem = Vue.extend({
  name: 'BasicAndIntermediateTypingItem',
  props: {
    letter: {
      type: String
    },
    input: {
      type: String
    },
    itemState: {
      type: String
    }
  },
  computed: {
    inputLetter () {
      return this.input !== null ? this.input : this.letter
    },
    letterStyle () {
      return this.itemState === 'completed' ? 'completed' : null
    },
    inputLetterStyle () {
      return this.itemState === 'completed' ? null : this.itemState
    }
  }
})
export default BasicAndIntermediateTypingItem
</script>

<style lang="scss" scoped>
#typing-test-basic-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 58px;
  height: 180px;
}

.letter-wrapper {
  height: 90px;
  color: #fff;
  font-size: 70px;
  font-weight: 500;
  text-align: center;

  &.key-in {
    color: #51ea8b; // #e3baec;
  }

  &.completed {
    color: #51ea8b;
  }

  &.error {
    color: #ed1c24;
    min-width: 40px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.7);
  }

  &.hidden {
    display: none;
  }
}
</style>
